// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8 {
  align-items: center;
  border: 2px dashed #B9B9B9;
  display: inline-flex;
  flex-direction: column;
  height: 175px;
  justify-content: center;
  outline: none;
  text-align: center;
  width: 550px;
}

.src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8:hover {
  cursor: pointer;
}

.src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8.src-js-account-settings-branding-image-upload-module__imageWillBeAccepted--cz9vM,
.src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8.src-js-account-settings-branding-image-upload-module__imageAccepted--OUYSs {
  background-color: rgba(0, 100, 0, .2);
  border-color: #006400;
}

.src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8.src-js-account-settings-branding-image-upload-module__imageWillBeRejected--zDLQX,
.src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8.src-js-account-settings-branding-image-upload-module__imageRejected--QmrSs {
  background-color: rgba(192, 35, 35, .2);
  border-color: #c02323;
}

.src-js-account-settings-branding-image-upload-module__imageAcceptedStatusIcon--qskWl {
  color: #006400;
}

.src-js-account-settings-branding-image-upload-module__imageRejectedStatusIcon--xmim0 {
  color: #c02323;
}

.src-js-account-settings-branding-image-upload-module__imageAcceptedStatusIcon--qskWl,
.src-js-account-settings-branding-image-upload-module__imageRejectedStatusIcon--xmim0 {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/account/settings/branding/image-upload.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;;EAEE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB","sourcesContent":[".uploadTarget {\n  align-items: center;\n  border: 2px dashed #B9B9B9;\n  display: inline-flex;\n  flex-direction: column;\n  height: 175px;\n  justify-content: center;\n  outline: none;\n  text-align: center;\n  width: 550px;\n}\n\n.uploadTarget:hover {\n  cursor: pointer;\n}\n\n.uploadTarget.imageWillBeAccepted,\n.uploadTarget.imageAccepted {\n  background-color: rgba(0, 100, 0, .2);\n  border-color: #006400;\n}\n\n.uploadTarget.imageWillBeRejected,\n.uploadTarget.imageRejected {\n  background-color: rgba(192, 35, 35, .2);\n  border-color: #c02323;\n}\n\n.imageAcceptedStatusIcon {\n  color: #006400;\n}\n\n.imageRejectedStatusIcon {\n  color: #c02323;\n}\n\n.imageAcceptedStatusIcon,\n.imageRejectedStatusIcon {\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadTarget": `src-js-account-settings-branding-image-upload-module__uploadTarget--pAyk8`,
	"imageWillBeAccepted": `src-js-account-settings-branding-image-upload-module__imageWillBeAccepted--cz9vM`,
	"imageAccepted": `src-js-account-settings-branding-image-upload-module__imageAccepted--OUYSs`,
	"imageWillBeRejected": `src-js-account-settings-branding-image-upload-module__imageWillBeRejected--zDLQX`,
	"imageRejected": `src-js-account-settings-branding-image-upload-module__imageRejected--QmrSs`,
	"imageAcceptedStatusIcon": `src-js-account-settings-branding-image-upload-module__imageAcceptedStatusIcon--qskWl`,
	"imageRejectedStatusIcon": `src-js-account-settings-branding-image-upload-module__imageRejectedStatusIcon--xmim0`
};
export default ___CSS_LOADER_EXPORT___;
